import React, { memo, Fragment, useState } from 'react';
import { string } from 'prop-types';
import get from 'lodash/get';
import { push } from 'connected-react-router';
import Button from '@material-ui/core/Button';
import { useDispatch, useSelector } from 'react-redux';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import { formatDate } from '../helpers/dateFormat';
import { getFormsPdf } from '../Appointment/actions';
import { makeStyles } from '@material-ui/core/styles';

const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
});

function Row(props) {
  const dispatch = useDispatch();
  const { row } = props;
  const [open, setOpen] = React.useState(false);
  const classes = useRowStyles();

  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)} disabled={get(row, 'questions', []).length === 0}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell>{formatDate(row.createdAt, 'MM/DD/YYYY')}</TableCell>
        <TableCell>{formatDate(row.completedAt, 'MM/DD/YYYY')}</TableCell>
        <TableCell>{row.score}</TableCell>
        <TableCell>
          <Button
            size={'small'}
            color={'inherit'}
            disableFocusRipple
            disableRipple
            style={{
              fontFamily: 'Lato',
              fontSize: 13,
              borderColor: '#858585',
              border: '1px solid #858585',
              color: '#42424',
              fontWeight: 400,
              backgroundColor: 'rgb(255, 255, 255)',
              textTransform: 'none',
            }}
            onClick={() =>
              dispatch(
                getFormsPdf({
                  reportSourceType: 'Appointment',
                  reportSourceId: row.appointmentId,
                  id: row.surveyId,
                  type: 'survey',
                  source: 'WebForm',
                }),
              )
            }
          >
            View
          </Button>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                Outcome Details
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell style={{ fontWeight: 'bold' }}>Question</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>Answer</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }} align="right">
                      Score
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {get(row, 'questions', []).map(questionRow => (
                    <TableRow key={questionRow.id}>
                      <TableCell component="th" scope="row">
                        {questionRow.title}
                      </TableCell>
                      <TableCell>{get(questionRow, 'answers', []).join()}</TableCell>
                      <TableCell align="right">{questionRow.score}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

function OutcomesTable(props) {
  const dispatch = useDispatch();
  const outcomesData = useSelector(state => state.patientOutcomes.surveyAnalyticsData);
  return (
    <Fragment>
      <Table responsive>
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell style={{ fontWeight: 'bold' }}>Date Sent</TableCell>
            <TableCell style={{ fontWeight: 'bold' }}>Date Filled</TableCell>
            <TableCell style={{ fontWeight: 'bold' }}>Score</TableCell>
            <TableCell style={{ fontWeight: 'bold' }}>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {outcomesData.map((out, i) => (
            <Row key={out.id} row={out} />
          ))}
        </TableBody>
      </Table>
    </Fragment>
  );
}

OutcomesTable.propTypes = {};

export default memo(OutcomesTable);
